import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subject} from 'rxjs/Subject';

import {RequestParameters} from '../../models/request-parameters/parameter.model';
import {Permission} from '../../../parameters/roles/permission.model';
import {PermissionService} from '../../../parameters/roles/permission.service';

@Component({
  selector: 'app-permissions-selector',
  templateUrl: './permissions-selector.component.html',
  styleUrls: ['./permissions-selector.component.scss']
})
export class PermissionsSelectorComponent implements OnInit {

  @Input('placeholder') placeholder: string;
  @Input('permissionType') permissionType: Subject<string>;
  @Input('initialPermissionType') initialPermissionType: string;
  @Input('permissionFormControl') permissionFormControl: FormControl;

  @Output() onPermissionsChanged: EventEmitter<any> = new EventEmitter<any>();

  permissions: Permission[] = [];
  permissionLoading: boolean = false;
  permissionParameters: RequestParameters = new RequestParameters();

  constructor(private permissionService: PermissionService) {

  }

  ngOnInit() {
    this.permissionFormControl.disable();
    if (this.initialPermissionType === 'CLK' || this.initialPermissionType === 'PARTNER' || this.initialPermissionType === 'EXTERNAL') {
      this.permissionParameters.searchString = this.initialPermissionType;
      this.updatePermission();
    }
    this.permissionType.subscribe(
      (permissionType) => {
        this.permissionParameters.searchString = permissionType;
        this.updatePermission();
      }
    );

  }

  onPermissionsChange(e) {
    this.onPermissionsChanged.emit(true) ;
  }

  updatePermission () {
    this.permissionLoading = true;
    this.permissionService.getPermissions(this.permissionParameters)
      .subscribe(
        (response) => {
          this.permissions = response.result.filter(
            (permission: Permission) => {
              if (permission.name.startsWith(response.parameters.searchString)) {
                return true;
              }
            }
          );
          this.permissionFormControl.enable();
          this.permissionLoading = false;
        }
      );
  }

  compareWithFn(item1, item2) {
    return item1 && item2 ? item1.reference === item2.reference : item1 === item2;
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/permissions-selector/permissions-selector.component.ts